import { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as types from '@/vdp/VehicleDetailsContainer/actionTypes';
import GlobalContext from '~/context/vdp/GlobalContext';
import { type FavoritesArguments } from '~/hooks/common/favorites';
import { getUser, getVehicleId } from '~/selectors';
import { removeFavorite } from '~/services/common';
import sendFavoriteMessageToNative from './sendFavoriteMessageToNative';
import { setCurrentVehicleFavorited } from './useGetFavorites';

const removeFavoriteLoading = () => ({
  type: `${types.REMOVE_FAVORITE}_LOADING`
});

const removeFavoriteSuccess = () => ({
  type: `${types.REMOVE_FAVORITE}_SUCCESS`
});

const removeFavoriteError = payload => ({
  type: `${types.REMOVE_FAVORITE}_ERROR`,
  error: true,
  payload
});

function useRemoveFavorite() {
  const { triggerEvent } = useContext(GlobalContext);
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector(getUser);
  const currentVehicleId = useSelector(getVehicleId);

  return useCallback(
    async ({ stockNumber = 0, vehicleId }: FavoritesArguments) => {
      if (!isLoggedIn) return;

      const isCurrentVehicle = currentVehicleId === vehicleId;

      try {
        if (isCurrentVehicle) {
          dispatch(setCurrentVehicleFavorited({ isFavorited: false }));
        }
        dispatch(removeFavoriteLoading());
        await removeFavorite(vehicleId);
        dispatch(removeFavoriteSuccess());
        sendFavoriteMessageToNative('remove', {
          stockNumber,
          vehicleId
        });
        triggerEvent.favoriteRemove();
      } catch (err) {
        dispatch(removeFavoriteError(err));
        if (isCurrentVehicle) {
          dispatch(setCurrentVehicleFavorited({ isFavorited: true }));
        }
      }
    },
    [currentVehicleId, dispatch, isLoggedIn, triggerEvent]
  );
}

export default useRemoveFavorite;
